export class CourseListModal {
  constructor() {
    // モーダル本体と開閉トリガーを取得
    this.modals = [...document.querySelectorAll('.js-course-list-modal')]
    this.triggers = [...document.querySelectorAll('.js-course-list-modal-trigger')]
    this.activeModal = null
    this.activeTrigger = null

    // 対象要素がないページでは何もしない
    if (this.modals.length === 0 || this.triggers.length === 0) return

    this._bindEvents()
  }

  // 開く・閉じる・背景クリックの各イベントを初期化時に一度だけ登録
  _bindEvents() {
    this.triggers.forEach((trigger) => {
      trigger.addEventListener('click', () => {
        this.open(trigger.dataset.modalTarget, trigger)
      })
    })

    this.modals.forEach((modal) => {
      modal.querySelectorAll('.js-course-list-modal-close').forEach((closeButton) => {
        closeButton.addEventListener('click', () => this.close(modal))
      })

      // ::backdrop部分のクリックはdialog自身がevent.targetになる
      modal.addEventListener('click', (event) => {
        if (event.target === modal) this.close(modal)
      })

      // Escapeキーを含むネイティブのクローズ後の共通処理
      modal.addEventListener('close', () => this._afterClose(modal))
    })
  }

  // 指定IDのモーダルを開き、見出しにフォーカスを移動
  open(id, trigger) {
    const modal = document.getElementById(id)
    if (typeof HTMLDialogElement === 'undefined' || !(modal instanceof HTMLDialogElement) || !modal.classList.contains('js-course-list-modal')) return

    if (this.activeModal?.open) this.activeModal.close()

    this.activeModal = modal
    this.activeTrigger = trigger
    document.body.classList.add('is-modal-open')
    modal.showModal()

    const title = modal.querySelector('.student-work-modal__title')
    title?.focus()
  }

  // 指定されたモーダル（省略時は現在開いているもの）を閉じる
  close(modal = this.activeModal) {
    if (typeof HTMLDialogElement === 'undefined' || !(modal instanceof HTMLDialogElement) || !modal.open) return

    modal.close()
  }

  // スクロールロックを解除し、開く前のトリガーにフォーカスを戻す
  _afterClose(modal) {
    if (modal !== this.activeModal) return

    const trigger = this.activeTrigger
    this.activeModal = null
    this.activeTrigger = null
    document.body.classList.remove('is-modal-open')

    trigger?.focus()
  }
}
